const BASE_URL = 'https://hmiqr.com'
// const BASE_URL = 'https://heresmyinfo.com' // Potential future switch

// Generates the web link that users share
export const inviteDeepLink = inviteId =>
  `${BASE_URL}/invite/${inviteId}`

export const connectionDeepLink = connectionId =>
  `${BASE_URL}/hmiconnections/${connectionId}`

export const QRDeepLink = code =>
  `${BASE_URL}/qr/${code}`

export const lastLink = () =>
  `${BASE_URL}/last`

// Generates the Custom Scheme URL for the App
// "heresmyinfo" is the scheme defined in app.json and ios/android configs
const APP_SCHEME = 'heresmyinfo'

export const inviteAppScheme = inviteId =>
  `${APP_SCHEME}://invite/${inviteId}`

export const connectionAppScheme = connectionId =>
  `${APP_SCHEME}://hmiconnections/${connectionId}`

